import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Error404Page } from './_layout/404.js';
import { RouteGuard } from '@/components/route-guard.js';

export const Route = createRootRoute({
  component: () => (
    <RouteGuard>
      <Outlet />
      {/* <TanStackRouterDevtools /> */}
    </RouteGuard>
  ),
  notFoundComponent: Error404Page,
});
